export default __webpack_public_path__ + "static/media/welcome_m@3x.b7c0666c.png";